import React from 'react';
import { Container } from 'library';

import Block from '../../blocks/Block';
import CMSContent from '../../common/CMSContent/CMSContent';
import Layout from '../../layout';

import './BasicSingleColumn.scss';

const BasicSingleColumn = ({ data }) => {
  const { page } = data;
  const { title, content, templateFields } = page;
  const blocks = templateFields.blocks;
  const { shouldDisplayTitle } = templateFields.blocksOnlyFields;

  return (
    <Layout>
      {(shouldDisplayTitle || content) && (
        <Container row justify="center" space={2}>
          <Container grid="10">
            {shouldDisplayTitle && <h1 className="BasicSingleColumnHeader">{title}</h1>}
            {content && <CMSContent content={content} />}
          </Container>
        </Container>
      )}

      {blocks?.map((block, index) => (
        <Block data={block} key={index} />
      ))}
    </Layout>
  );
};

export default BasicSingleColumn;
